export default __webpack_public_path__ + "static/media/relax.b6fe4493.jpg";